import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import React from 'react';
import goldTierBadge from '../../../../assets/loyalty/gold-tier.svg?reference';
import { Flex } from '../../../ui';
import ArrowIcon from '../../../ui/new-assets/arrow.svg';
import { Button } from '../../../ui/new-components/Button';
import Responsive from '../../../ui/utils/Responsive';
import { trackRewardOffersBannerTap } from '../../account/ui/shared/analytics/trackRewardOffersBannerTap';
import { useIsAuthenticatedAfterHydration } from '../../auth/shared/store/useIsAuthenticatedAfterHydration';
import { SIGN_UP_DIALOG_HASH } from '../../auth/sign-up/ui/SignUpDialog';
import { SolidContentWrap } from '../../shared/components';
import { useTranslation } from '../../shared/i18n/translate/useTranslation';
import { useLocation } from '../../shared/router/useLocation';
import { getGradientBackground } from '../../shared/styles';

export const GuestBanner = observer(() => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const isAuthenticated = useIsAuthenticatedAfterHydration();

	const isTablet = Responsive.useMatchesBreakpoint('tablet');

	if (isAuthenticated) {
		return null;
	}

	return (
		<StyledSolidContentWrap>
			<StyledFlex>
				<StyledTitleActionContainer>
					<StyledTitleContainer>
						<h2>{t('dashboard_guest_banner_title')}</h2>
					</StyledTitleContainer>
					<StyledFlex>
						<StyledItemContainer
							onClick={() => {
								trackRewardOffersBannerTap(pathname);
							}}
						>
							<Button
								variant="secondary"
								href={SIGN_UP_DIALOG_HASH}
								icon={<ArrowIcon aria-hidden />}
								className="w-full"
							>
								{t('user_create_account_title')}
							</Button>
						</StyledItemContainer>
						{isTablet && (
							<StyledItemContainer>
								<StyledImage src={goldTierBadge} alt="" />
							</StyledItemContainer>
						)}
					</StyledFlex>
				</StyledTitleActionContainer>

				{!isTablet && (
					<StyledItemContainer>
						<StyledImage src={goldTierBadge} alt="" />
					</StyledItemContainer>
				)}
			</StyledFlex>
		</StyledSolidContentWrap>
	);
});

const StyledSolidContentWrap = styled(SolidContentWrap)`
	height: 205px;
	border-radius: 12px;
	h2 {
		font-size: 32px;
		color: #fff;
		line-height: 40px;
		margin: 0;
	}

	${getGradientBackground('purple-blue')}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: fit-content;
		padding: 16px;
		margin: 12px 16px;

		h2 {
			line-height: 26px;
			font-size: 22px;
		}
	}
`;

const StyledTitleActionContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		gap: 10px;
	}
`;

const StyledFlex = styled(Flex)`
	height: 100%;
	gap: 16px;
	flex-direction: row;
	align-content: space-between;
	align-items: center;
	justify-content: space-between;

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		gap: 12px;
	}
`;

const StyledTitleContainer = styled.div`
	flex-grow: unset;
	justify-content: center;
`;
const StyledItemContainer = styled.div`
	height: fit-content;
	display: flex;
`;

const StyledImage = styled.img`
	width: 115px;
	height: 130px;
	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		width: 57px;
		height: 65px;
	}
`;
